import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { isMasked } from '@miq/utils';
import { MiqBehaviors } from '@shared/behaviors';
import { TextInput } from '../text-input';

@Component({
  selector: 'miq-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  providers: [{ provide: MiqBehaviors, useExisting: TextareaComponent }],
  standalone: false,
})
export class TextareaComponent extends TextInput implements OnChanges {
  @ViewChild('textareaEl') textareaEl!: ElementRef<HTMLTextAreaElement>;

  @Input() declare currentValue: string;
  @Input() placeholder = '';

  @Output() currentValueChange = new EventEmitter<string>();

  isFocused = false;

  constructor(private ngZone: NgZone) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (!!changes.currentValue && !changes.currentValue.firstChange) {
      this.fc.setValue(this.currentValue);
      this.ngZone.onStable.subscribe(() => {
        this.resizeTextarea(this.textareaEl?.nativeElement);
      });
    }
  }

  onInput(el: HTMLTextAreaElement) {
    this.resizeTextarea(el);
  }

  private resizeTextarea(el: HTMLTextAreaElement | undefined) {
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
  }

  /**
   * Prevent user typing 5 stars which may lead to disable the input
   * then emit valid change
   */
  public onChange(val: string) {
    if (isMasked(val)) {
      val = '';
      this.fc.setValue(val);
    }
    return this.emitChange(val);
  }

  private emitChange(val: string) {
    this.currentValue = val;
    this.currentValueChange.emit(this.valueSetter ? this.valueSetter(val) : val);
  }
}
